<mat-card
    style="box-shadow:none;    padding: 0px !important;"
    [class.mat-elevation-z1]="'true'"
>
    <mat-card-header>
        <mat-card-title>2FA Authentication</mat-card-title>
    </mat-card-header>
    <mat-divider></mat-divider>
        <mat-dialog-content>
            <form [formGroup]="form">
            <div>
                <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 10px;">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Enter 2FA Code</mat-label>
                    <input matInput type="text" placeholder="code" formControlName="code" style="color: #777777; padding-bottom: 2px;" />
                    <mat-error *ngIf="form.controls.code.invalid && form.controls.code.touched">Code is required</mat-error>
                </mat-form-field>
                </div>
            </div>
            </form>
      </mat-dialog-content>
      <mat-dialog-actions>
      <button style="  font-size: 10px;
margin-right: 5px;
scale: 1;
background: #bf1e2e;
color: white;
border-radius: 0px;
text-shadow: none;
box-shadow: none;
flex: 1 1 100%;
box-sizing: border-box;
max-width: 50px;
cursor: pointer;
transition: background-color 0.3s;
box-shadow: none !important;" mat-raised-button (click)="onCancelClick()">Close</button>
<button
style="  font-size: 10px;
margin-right: 5px;
scale: 1;
background: #bf1e2e;
color: white;
border-radius: 0px;
text-shadow: none;
box-shadow: none;
flex: 1 1 100%;
box-sizing: border-box;
max-width: 65px;
cursor: pointer;
transition: background-color 0.3s;
box-shadow: none !important;" mat-raised-button (click)="addClick()" type="submit">Submit</button>
</mat-dialog-actions>
</mat-card>
